import Configuracao from '@/misc/Configuracao';
import RouterStore from '@/store/RouterStore';
import { DadosProcessoBTV } from '../modelo/DadosProcessoBTV';
import { AlertaDto } from '../modelo/dto/AlertaDto';
import { DadosProcessoDto } from '../modelo/dto/DadosProcessoDto';
import { PartesDto } from '../modelo/dto/PartesDto';
import { PecaDto } from '../modelo/dto/PecaDto';
import { TarefasFluxoDto } from '../modelo/dto/TarefasFluxoDto';
import MapeadorMapaProcesso from '../services/mapeadores/MapeadorMapaProcesso';
import Ambiente from "../utils/Ambiente";
import { IIndicadores } from './../modelo/Indicadores';
import fetch from './AxiosAdapter';
import { buscarSsoTokenStorage, possuiSsoTokenStorage } from '@/utils/SsoCookieUtils';

export interface FeedbackAguiaPayload {
    idSequencialAssunto: number | string;
    nomePropriedade: string;
    valorPropriedade?: string;
    funcionalidade: string;
    nota: number;
    comentario?: string;
}

export interface FeedbackAguia {
    id_processo: string;
    id_sequencial_assunto: number;
    nome_propriedade: string;
    funcionalidade: string;
    nota: number;
    comentario?: string;
    dt_feedback?: string;
    valor_propriedade?: string;
}

class InformacoesProcessoApi {

    private get headersAguia() {
        const ssoToken = buscarSsoTokenStorage();
        return {
            'Accept': '*/*',
            ...(ssoToken ? { ssoToken: ssoToken } : {})
        };
    }

    async consultarProcesso(idProcesso: number): Promise<DadosProcessoDto> {
        const result = await fetch<DadosProcessoDto>(Configuracao.urlProcessosGE + idProcesso);
        if (result.status !== 200) {
            throw new Error('Processo não encontrado.');
        }
        return result.data;
    }

    async consultarPartesProcesso(idProcesso: number): Promise<Map<number, PartesDto>> {
        const result = await fetch<Map<number, PartesDto>>(Configuracao.urlProcessosGE + 'partes', { method: 'POST', data: [idProcesso] });
        return result.data;
    }

    async consultarPartesDaListaDeProcesso(idsProcesso: number[]): Promise<Map<number, PartesDto>> {
        if (idsProcesso.length) {
            const result = await fetch(`${Configuracao.urlProcessosGE}partes`, {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json'
                },
                data: idsProcesso
            });
            return MapeadorMapaProcesso.toMap(result.data);
        }
        return new Map();
    }
    async consultarIndicadoresDaListaDeProcesso(idsProcesso: number[]): Promise<IIndicadores[][]> {
        if (idsProcesso.length) {
            const result = await fetch<IIndicadores[][]>(Configuracao.urlIndicadores + 'todos', {
                method: 'POST',
                body: idsProcesso
            });
            return result.data as IIndicadores[][];
            // return MapeadorMapaProcesso.toMap(result.data);
        }
        return [];
    }

    async consultarDocumentosProcesso(idProcesso: number): Promise<PecaDto[]> {
        const result = await fetch<PecaDto[]>(Configuracao.urlProcessosGE + idProcesso + '/documentos');
        return result.data.filter(peca => peca.assinado);
    }

    async consultarJurisprudencia(numero: string, ano, digito, justica, tribunal, vara): Promise<JurisprudenciaDTO> {
        const result = await fetch<JurisprudenciaDTO>(Configuracao.urlJurisprudencia, {
            method: "POST",
            body: {
                "numeracaoUnica": {
                    "numero": numero,
                    "ano": ano,
                    "digito": digito,
                    "orgao": justica,
                    "tribunal": tribunal,
                    "vara": vara
                },
                tipos: [
                    "ACORDAO",
                    "DESPACHO",
                    "SUM",
                    "PN",
                    "OJ",
                    "DESPGP",
                    "DESPGVP",
                    "DESPGCG"
                ]
            }

        });
        return result.data;
    }

    //MANTEM
    //TODO retirar as any
    async consultarConteudoDocumentoProcesso(idProcesso, idDocumento, tipo): Promise<any> {
        if (tipo !== 'PDF') {
            let result;
            if (tipo === 'GED') {
                if (RouterStore.isPrd) {
                    result = await fetch(Configuracao.urlMinuta + idDocumento + '/assinada');
                } else {
                    result = await fetch(Configuracao.urlMinutaGE + idDocumento + '/assinada');
                }
            } else if (tipo === 'HTML') {
                result = await fetch(Configuracao.urlDocumentos + idProcesso + '/' + idDocumento + '/conteudoHTML');
            } else {
                result = await fetch(Configuracao.urlDocumentos + idProcesso + '/' + idDocumento + '/conteudo');
            }
            return result.data;
        } else {
            if (idProcesso.toString().length === 12) {
                if (RouterStore.isPrd) {
                    return Configuracao.urlProcessos + 'id/' + idProcesso + '/documentoPJe/id/' + idDocumento;
                } else {
                    return Configuracao.urlProcessosGE + 'id/' + idProcesso + '/documentoPJe/id/' + idDocumento;
                }

            } else {
                // ex. https://pje-hml.tst.jus.br/pje-comum-api/api/processos/id/35200/documentos/id/2954559/conteudo?incluirCapa=false&incluirAssinatura=true
                const urlRedirect = Ambiente.urlPJe.split("pjekz")[0] + "pje-comum-api/api/processos/id/" + idProcesso + '/documentos/id/' + idDocumento + '/conteudo?incluirCapa=false&incluirAssinatura=true';
                const tokenLocal = (window as any).loginClient.tokenService.buscarTokenLocal?.();
                const tokenLogus = tokenLocal?.token ? JSON.parse(atob(tokenLocal.token.split(".")[0])) : null;
                const kzToken = tokenLogus?.tokens?.kz?.token;
                const idPerfil = kzToken ? JSON.parse(atob(kzToken.split(".")[1]))?.perfil : undefined;
                const refreshToken = tokenLogus?.tokens?.kz_refresh?.token;

                const redirectPageWithSSO = Ambiente.urlPJe.split("pjekz")[0] + "btv/bemtevi/tst-sso.html?id_perfil=" + idPerfil + "&redirect_url=" + urlRedirect + "&refresh_token=" + refreshToken;

                return redirectPageWithSSO;
            }
        }
    }

    async consultarAlertasProcesso(idProcesso: number): Promise<AlertaDto[]> {
        const result = await fetch<AlertaDto[]>(Configuracao.urlProcessosGE + idProcesso + '/alertas');
        let alertas = [];
        if (result.status === 200) {
            alertas = result.data;
        }
        return alertas;
    }

    async consultarTarefaFluxoPJe(idProcesso: number): Promise<TarefasFluxoDto> {
        const result = await fetch<TarefasFluxoDto>(Configuracao.urlProcessoTarefaFluxoJbpmPje + idProcesso);
        return result.data;
    }

    consultarConteudoCertidao(idProcesso, idDocumento) {
        // return await fetch(Configuracao.urlProcessosGE + idProcesso + '/documentos/' + idDocumento + '/certidao');
        return Configuracao.urlProcessosGE + idProcesso + '/documentos/' + idDocumento + '/certidao';
    }

    consultarConteudo(idProcesso, idDocumento) {
        // return await fetch(Configuracao.urlProcessosGE + idProcesso + '/documentos/' + idDocumento + '/certidao');
        //id/${codIdProcesso}/documentoPJe/id/${idDocumento}
        if (RouterStore.isPrd) {
            return Configuracao.urlProcessosSessao + 'id/' + idProcesso + '/documentoPJe/id/' + idDocumento;
        } else {
            return Configuracao.urlProcessosGE + 'id/' + idProcesso + '/documentoPJe/id/' + idDocumento;
        }
    }

    async consultarPeticoesPendentes(idProcesso: number): Promise<PecaDto[]> {
        const peticoes = await this.consultarPeticoes(idProcesso);

        return peticoes.filter(peticao => peticao.codigoPeticaoStatus == null ? true : !([6, 7].includes(peticao.codigoPeticaoStatus)));
    }

    async consultarPeticoes(idProcesso: number): Promise<PecaDto[]> {
        //FIXME
        const result = await fetch<PecaDto[]>(Configuracao.urlProcessosGE + idProcesso + '/peticoes');
        return result.data;
    }

    async consultarTodasPeticoesPendentes(idsProcessos: number[]): Promise<Map<number, PecaDto[]>> {
        console.info("deprecated - tente usar EscaninhoPeticaoService");
        const result = await fetch<Map<number, PecaDto[]>>(Configuracao.urlProcessosGE + 'todos/peticoes',
            {
                method: 'POST',
                body: idsProcessos
            });
        return result.data;
    }

    async consultarDocumentoPorId(idProcesso, idDocumento) {
        if (RouterStore.isPrd) {//MIGRADO
            const result = await fetch(Configuracao.urlProcessosSessao + idProcesso + '/documentos/' + idDocumento);
            return result.data;
        }

        const result = await fetch(Configuracao.urlProcessosGE + idProcesso + '/documentos/' + idDocumento);
        return result.data;
    }

    async consultarQuantidadePeticoesPendentes(idProcesso: number): Promise<Map<number, number>> {
        const result = await fetch<Map<number, number>>(Configuracao.urlProcessosGE + 'peticoes/count', {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json'
            },
            data: [idProcesso]
        });
        return result.data;
    }

    async consultarQuantidadePeticoesPendentesDaListaDeProcesso(idsProcesso: number[]): Promise<number[]> {
        if (idsProcesso.length) {
            const result = await fetch<number[]>(`${Configuracao.urlProcessosGE}peticoes/count`, {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json'
                },
                data: idsProcesso
            });
            return result.data;
        }
        return [];
    }

    async consultarRetornosDaListaDeProcesso(idsProcesso: number[]): Promise<boolean[]> {
        if (idsProcesso.length) {
            const result = await fetch<boolean[]>(`${Configuracao.urlProcessosGE}retorno-gabinete`, {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json'
                },
                data: idsProcesso
            });
            return result.data;
        }
        return [];
    }

    async consultarRetornosDeProcesso(idProcesso: number): Promise<Map<number, boolean>> {
        if (idProcesso) {
            const result = await fetch(`${Configuracao.urlProcessosGE}retorno-gabinete`, {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json'
                },
                data: [idProcesso]
            });
            return MapeadorMapaProcesso.toMap(result.data);
        }
        return new Map();
    }

    async consultarMovimentos(idsProcesso: number[]): Promise<[][]> {
        // const result = await fetch<IMovimento[]>(Configuracao.urlProcessosGE + idProcesso + '/movimentos');
        const result = await fetch<[][]>(Configuracao.urlProcessosGE + 'recuperar-movimentos',
            {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json'
                },
                data: idsProcesso
            });

        const movimentos = result.data;
        return movimentos;
    }

    async buscarSituacaoInclusaoPautaDaListaDeProcessos(idsProcesso: number[]) {
        if (idsProcesso.length) {
            const result = await fetch(`${Configuracao.urlProcessosGE}situacao-inclusao-pauta`, {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json'
                },
                data: idsProcesso
            });
            return result.data;
        }
        return [];
    }

    async buscarResultadoDeJulgamentoDaListaDeProcessos(idsProcesso: number[]) {
        if (idsProcesso.length) {
            const result = await fetch(`${Configuracao.urlProcessosGE}resultados-julgamentos`, {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json'
                },
                data: idsProcesso
            });
            return result.data;
        }
        return [];
    }

    async buscarProcessosComAgProvido(idsProcesso: number[]) {
        if (idsProcesso.length) {
            const result = await fetch(Configuracao.urlProcessosComAgProvido, {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json'
                },
                data: idsProcesso
            });
            return result.data;
        }
        return [];
    }

    async buscarPartesProcessoBTV(gabinete: string): Promise<DadosProcessoBTV[]> {
        const result = await fetch(Configuracao.urlDadosBemTeVi + '?gabinete=' + gabinete)
        return result.data as DadosProcessoBTV[];
    }

    async consultarResumoDocumentosAguia(idProcesso: number, isSilent = false) {
        const result = await fetch(Configuracao.urlResumoConsolidadoDocumentosAguia.replace('{ID_PROCESSO}', idProcesso.toString()) + '?classeProcesso=AIRR', {
            method: 'GET',
            silent: isSilent ? true : false,
            withCredentials: true,
            skipAuthentication: possuiSsoTokenStorage(),
            headers: this.headersAguia
        })
        return result.data as any
    }

    async gerarResumoDocumentosAguia(idProcesso: number) {
        const result = await fetch(Configuracao.urlResumoConsolidadoDocumentosAguia.replace('{ID_PROCESSO}', idProcesso.toString()) + '?classeProcesso=AIRR', {
            method: 'POST',
            withCredentials: true,
            skipAuthentication: possuiSsoTokenStorage(),
            headers: this.headersAguia
        })
        return result.data as any
    }

    async consultarFeedbackAguia(idProcesso: number) {
        const result = await fetch(Configuracao.urlFeedbackAguia.replace('{ID_PROCESSO}', idProcesso.toString()), {
            method: 'GET',
            silent: true,
            withCredentials: true,
            skipAuthentication: possuiSsoTokenStorage(),
            validateStatus: (status) => status < 400 || status === 404,
            headers: this.headersAguia
        });

        if (result.status === 404) {
            return [];
        }

        return result.data as FeedbackAguia[] | { feedbacks: FeedbackAguia[] };
    }

    async gerarFeedbackAguia(idProcesso: number, feedbackAguia: FeedbackAguiaPayload) {
        const params = new URLSearchParams();

        params.set('id_sequencial_assunto', feedbackAguia.idSequencialAssunto.toString());
        params.set('nome_propriedade', feedbackAguia.nomePropriedade);
        params.set('funcionalidade', feedbackAguia.funcionalidade);
        params.set('nota', feedbackAguia.nota.toString());

        if (feedbackAguia.comentario?.trim()) {
            params.set('comentario', feedbackAguia.comentario.trim());
        }

        if (feedbackAguia?.valorPropriedade) {
            params.set('valor_propriedade', feedbackAguia.valorPropriedade);
        }

        await fetch(`${Configuracao.urlFeedbackAguia.replace('{ID_PROCESSO}', idProcesso.toString())}?${params.toString()}`, {
            method: 'POST',
            withCredentials: true,
            skipAuthentication: possuiSsoTokenStorage(),
            headers: this.headersAguia
        });
    }

}

export default new InformacoesProcessoApi();
